
import React from 'react'
import { Select, SelectProps } from 'antd';
import { PromotionWayMap } from '../FilterFullPromotion/service';


export interface FilterPromotionWayProps extends SelectProps {}

export const FilterPromotionWay = (props: FilterPromotionWayProps) => {
  const { placeholder = '促销方式', mode, ...reset } = props;
  const options = Object.entries(PromotionWayMap).map(([value, label]) => ({ label, value }))
  
  return (
    <Select
      style={{ width: '100%' }}
      mode={mode}
      options={options}
      placeholder={placeholder}
      {...reset}
    />
  )
}